var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-div"},[_c('div',{staticClass:"preview-bg"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }